import { render } from "./ReceiptList.vue?vue&type=template&id=b451ff74&scoped=true"
import script from "./ReceiptList.vue?vue&type=script&lang=js"
export * from "./ReceiptList.vue?vue&type=script&lang=js"

import "./ReceiptList.vue?vue&type=style&index=0&id=b451ff74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b451ff74"]])

export default __exports__